import React from "react";
//components
import AeroButton from "../../../components/aeroButton/index";
//images
import msnLogo from "./assets/msn-logo.png";
import { Container } from "./styles";

const sidebar = () => {
    return (
        <Container>
            <AeroButton className="button">
                <img src={msnLogo} alt="" />
            </AeroButton>
        </Container>
    );
};

export default sidebar;
